import { Box, Heading, StyledIcon, TextBlock } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";

import style from "./grade-badge.scss";
import { resolveColor } from "utils/commonFunctions";

export type Grade = "A" | "B" | "C" | "D";

export const isGrade = (value: unknown): value is Grade =>
    value === "A" || value === "B" || value === "C" || value === "D";

const BADGE_COLOR: Record<Grade, string> = {
    A: "--app-first-grade-badge-color",
    B: "--app-second-grade-badge-color",
    C: "--app-third-grade-badge-color",
    D: "--app-fourth-grade-badge-color",
};

const BADGE_BACKGROUND_COLOR: Record<Grade, string> = {
    A: "--app-first-grade-badge-backgroundColor",
    B: "--app-second-grade-badge-backgroundColor",
    C: "--app-third-grade-badge-backgroundColor",
    D: "--app-fourth-grade-badge-backgroundColor",
};

interface Props {
    grade: Grade;
    size?: number;
    bold?: boolean;
    withBackground?: boolean;
    title?: string;
    description?: string;
}

export const GradeBadge = (props: Props) => (
    <Box
        className={classNames({ [style.background]: props.withBackground })}
        style={{ background: props.withBackground ? resolveColor(BADGE_BACKGROUND_COLOR[props.grade]) : undefined }}
    >
        <StyledIcon
            icon={<div className={classNames(style.gradeText, { [style.bold]: props.bold })}>{props.grade}</div>}
            size={props.size ?? 36}
            variant={"Square"}
            backgroundColor={resolveColor(BADGE_COLOR[props.grade])}
        />
        <Box columnLayout gap={"Xxxs"}>
            {props.title && (
                <Heading variant="SUBTITLE_2" disableTopSpacing disableBottomSpacing>
                    {props.title}
                </Heading>
            )}
            {props.description && <TextBlock disableBottomSpacing>{props.description}</TextBlock>}
        </Box>
    </Box>
);
